import { Link, ArrowCircleUpRight } from '@phosphor-icons/react'
import BugIcon from 'public/images/support/Bug.png'
import Magnifier from 'public/images/support/Magnifier.png'
import { useLocale } from 'src/lib/hooks/useLocal'
import ContactUsPopover from './ContactUsPopover'
import { show } from '@intercom/messenger-js-sdk'
import useGTM from 'src/lib/hooks/useGTM'

const SupportPageHeader = () => {
  const { t } = useLocale()
  const { sendGTMTrigger } = useGTM()
  return (
    <div className='gap-8 flex flex-col pb-8 border-b-1 border-coal-lighter'>
      <div className='flex flex-col gap-2'>
        <h3 className='text-carbon text-[40px] font-semibold'>{t('support.header')}</h3>
        <p className='text-gray-dark text-base font-medium'>{t('support.subtitle')}</p>
      </div>
      <div className='flex gap-6'>
        <ExternalLinkIcon
          link='https://www.example.com'
          startIcon={<img src={Magnifier.src} alt='Magnifier Icon' width={24} height={24} />}
          endIcon={<Link size={24} color='#1A1A1A' />}
          text='Shopflo help docs '
          handleClick={() => {
            sendGTMTrigger('support_page_button_clicked', 'click', {
              actionType: 'shopflo_help_docs'
            })
            window.open('https://www.shopflo.com/help', '_blank')
          }}
        />
        <ExternalLinkIcon
          link='https://support.shopflo.com/report'
          startIcon={<img src={BugIcon.src} alt='Bug Icon' width={24} height={24} />}
          endIcon={<ArrowCircleUpRight size={24} color='#1A1A1A' />}
          text='Report an Issue'
          handleClick={() => {
            sendGTMTrigger('support_page_button_clicked', 'click', {
              actionType: 'report_an_issue'
            })
            show()
          }}
        />
        <ContactUsPopover />
      </div>
    </div>
  )
}

interface ExternalLinkIconProps {
  link: string
  startIcon: React.ReactNode
  endIcon: React.ReactNode
  text: string
  handleClick: () => void
}

const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({ link, startIcon, endIcon, text, handleClick }) => {
  return (
    <div
      onClick={handleClick}
      rel='noopener noreferrer'
      className='flex items-center gap-4 py-3 px-4 bg-white rounded-xl border-1 border-coal-lighter transition hover:bg-gray-lighter cursor-pointer'
      style={{
        boxShadow: '0px -3px 1.3px 0px #0000001A inset'
      }}
    >
      <div className='flex items-center justify-center'>{startIcon}</div>
      <span className='text-sm font-medium text-carbon'>{text}</span>
      <div className='flex items-center justify-center'>{endIcon}</div>
    </div>
  )
}

export default SupportPageHeader
